import type { SourceFile } from "../sidebar/sources-types";

export type ResolveFacetAutogenerateSourceFailureReason =
    | "no_selection"
    | "invalid_type"
    | "no_es_index"
    | "invalid_id";

export type ResolveFacetAutogenerateSourceResult =
    | { ok: true; esIndex: string; sourceId: number }
    | { ok: false; reason: ResolveFacetAutogenerateSourceFailureReason };

export function resolveFacetAutogenerateSource(
    getNode: (id: string) => unknown,
    selectedSourceId: string | undefined
): ResolveFacetAutogenerateSourceResult {
    if (!selectedSourceId) return { ok: false, reason: "no_selection" };
    const node = getNode(selectedSourceId) as SourceFile | undefined;
    if (!node || node.type !== "dataRepo") return { ok: false, reason: "invalid_type" };
    const esIndex = node.es_index?.trim();
    if (!esIndex) return { ok: false, reason: "no_es_index" };
    const sourceId = Number(selectedSourceId);
    if (!Number.isFinite(sourceId)) return { ok: false, reason: "invalid_id" };
    return { ok: true, esIndex, sourceId };
}
